const colors = {
  primary1Color: '#00BCD4',
  primary2Color: '#4DD0E1',
  primary3Color: '#00838F',
  accent1Color: '#FFB74D',
  accent2Color: '#FF9800',
  accent3Color: '#EF6C00',
  background: '#FAFAFA',
  darkBlack: 'rgba(0, 0, 0, 0.87)'
};

export default colors;



// WEBPACK FOOTER //
// ./src/theme/Colors.js